<div [ngClass]="getContainerClass()">
  <!-- Breadcrumb com Voltar separado do caminho -->
  <nav aria-label="breadcrumb" *ngIf="breadcrumbs.length > 0">
    <div class="breadcrumb-container">
      <!-- Link Voltar separado -->
      <a href="#" class="voltar-link" (click)="goBack(); $event.preventDefault()">
        <i class="fa fa-chevron-left"></i> Voltar
      </a>
      
      <!-- Breadcrumb path -->
      <ol class="breadcrumb mb-0">
        <li 
          *ngFor="let item of breadcrumbs; let last = last" 
          class="breadcrumb-item"
          [class.active]="item.isActive || last"
          [attr.aria-current]="(item.isActive || last) ? 'page' : null"
        >
          <a 
            *ngIf="item.url && !item.isActive && !last" 
            href="#" 
            (click)="navigateTo(item); $event.preventDefault()"
          >
            {{ item.label }}
          </a>
          <span *ngIf="!item.url || item.isActive || last">
            {{ item.label }}
          </span>
        </li>
      </ol>
    </div>
  </nav>
</div> 